import React, { useState } from 'react';
import HamburgerMenu from '../global/menu';
import '../global/styles.css';

function GlasgowComaScale({ userInfo, isAdmin, onLogout, onNavigate }) {
  const [eyeOpening, setEyeOpening] = useState('4');
  const [verbalResponse, setVerbalResponse] = useState('5');
  const [motorResponse, setMotorResponse] = useState('6');
  const [totalScore, setTotalScore] = useState(null);
  const [interpretation, setInterpretation] = useState('');

  const handleCalculate = () => {
    const eye = parseInt(eyeOpening);
    const verbal = parseInt(verbalResponse);
    const motor = parseInt(motorResponse);
    const total = eye + verbal + motor;

    setTotalScore(total);

    // Interpretation based on total score
    let interp = '';
    if (total >= 13) {
      interp = 'Mild Injury (13-15)';
    } else if (total >= 9 && total <= 12) {
      interp = 'Moderate Injury (9-12)';
    } else {
      interp = 'Severe Injury (3-8)';
    }

    setInterpretation(interp);
  };

  const getInterpretationColor = () => {
    if (totalScore >= 13) return '#2e7d32'; // Green
    if (totalScore >= 9) return '#f57c00'; // Orange
    return '#c62828'; // Red
  };

  return (
    <div className="container-center" style={{ paddingBottom: '80px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="card card-center" style={{
        maxWidth: '700px',
        width: '100%',
        padding: '50px 40px'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
          borderBottom: '2px solid #0E3293',
          paddingBottom: '25px'
        }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#0E3293',
            margin: '0 0 15px 0',
            letterSpacing: '-0.5px'
          }}>
            Glasgow Coma Scale Calculator
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#777',
            margin: '0',
            lineHeight: '1.6'
          }}>
            Evaluate Eye Opening, Verbal Response, and Motor Response
          </p>
        </div>

        {/* GCS Form */}
        <div style={{
          background: '#f8f9fa',
          padding: '30px',
          borderRadius: '12px',
          marginBottom: '20px',
          boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
        }}>
          {/* Eye Opening */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#333',
              fontSize: '15px'
            }}>
              Eye Opening:
            </label>
            <select
              value={eyeOpening}
              onChange={(e) => setEyeOpening(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '15px',
                backgroundColor: 'white',
                cursor: 'pointer',
                outline: 'none'
              }}
            >
              <option value="1">1 - None</option>
              <option value="2">2 - To pain</option>
              <option value="3">3 - To speech</option>
              <option value="4">4 - Spontaneous</option>
            </select>
          </div>

          {/* Verbal Response */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#333',
              fontSize: '15px'
            }}>
              Verbal Response:
            </label>
            <select
              value={verbalResponse}
              onChange={(e) => setVerbalResponse(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '15px',
                backgroundColor: 'white',
                cursor: 'pointer',
                outline: 'none'
              }}
            >
              <option value="1">1 - None</option>
              <option value="2">2 - Incomprehensible sounds</option>
              <option value="3">3 - Inappropriate words</option>
              <option value="4">4 - Confused conversation</option>
              <option value="5">5 - Oriented</option>
            </select>
          </div>

          {/* Motor Response */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#333',
              fontSize: '15px'
            }}>
              Motor Response:
            </label>
            <select
              value={motorResponse}
              onChange={(e) => setMotorResponse(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '15px',
                backgroundColor: 'white',
                cursor: 'pointer',
                outline: 'none'
              }}
            >
              <option value="1">1 - None</option>
              <option value="2">2 - Abnormal extension (Decerebrate)</option>
              <option value="3">3 - Abnormal flexion (Decorticate)</option>
              <option value="4">4 - Withdrawal from pain</option>
              <option value="5">5 - Localizes pain</option>
              <option value="6">6 - Obeys commands</option>
            </select>
          </div>

          {/* Calculate Button */}
          <button
            onClick={handleCalculate}
            className="btn btn-primary btn-full"
            style={{
              background: '#0E3293',
              borderColor: '#0E3293',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            Calculate GCS
          </button>
        </div>

        {/* Results Display */}
        {totalScore !== null && (
          <div>
            <div style={{
              background: 'white',
              padding: '25px',
              borderRadius: '12px',
              border: '2px solid #e0e0e0',
              textAlign: 'center',
              marginBottom: '15px'
            }}>
              <p style={{
                margin: '0 0 10px 0',
                fontSize: '15px',
                color: '#666',
                fontWeight: '500'
              }}>
                Total GCS Score:
              </p>
              <span style={{
                fontSize: '48px',
                fontWeight: 'bold',
                color: '#0E3293'
              }}>
                {totalScore}
              </span>
            </div>

            <div style={{
              background: getInterpretationColor(),
              padding: '20px',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <p style={{
                margin: '0',
                fontSize: '18px',
                color: 'white',
                fontWeight: '600'
              }}>
                {interpretation}
              </p>
            </div>
          </div>
        )}

        {totalScore === null && (
          <div style={{
            background: 'white',
            padding: '25px',
            borderRadius: '12px',
            border: '2px solid #e0e0e0',
            textAlign: 'center'
          }}>
            <p style={{
              margin: '0',
              fontSize: '15px',
              color: '#999',
              fontStyle: 'italic'
            }}>
              Select values and click Calculate to see results
            </p>
          </div>
        )}
      </div>

      {/* Fixed Footer */}
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        background: '#ffffff',
        textAlign: 'center',
        padding: '15px 10px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
        zIndex: 9999,
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <img
            src="https://us.api.fliplet.com/v1/media/files/5174683/contents/blob"
            alt="NarcoticTrack Logo"
            style={{
              height: '32px',
              verticalAlign: 'middle'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: '#666',
            fontWeight: '400'
          }}>
            © 2025 NarcoticTrack Inventory System, LLC
          </span>
        </div>
      </footer>
    </div>
  );
}

export default GlasgowComaScale;
